
//ROADMAP API *** Using Module Pattern **
var ROADMAP = ROADMAP || {};

//Create a namespacing function
//Ensures no pollution
ROADMAP.namespace = function (ns_string) {
    var parts = ns_string.split('.'),
        parent = ROADMAP,
        i;

    //strip leading global
    if (parts[0] === "ROADMAP") {
        parts = parts.slice(1);
    }

    for(i = 0; i < parts.length; i += 1) {
        //create property if it doesn't exist
        if (typeof parent[parts[i]] === 'undefined') {
            parent[parts[i]] = {};
        }
        parent = parent[parts[i]];
    }
    return parent;
};


//Interactions with database service
//@module ROADMAP.service
ROADMAP.namespace('service');

ROADMAP.service = (function () {
    /* PRIVATE */
    var _service,
        _profiles = [],
        _mapServiceUrl,
        _legItems;

    /* PUBLIC */
    var data = {};

    //@returns Public API Interface in callback
    //@summary loads and prepares service json to
    //         use in mapping application
    //@param url : The database JSON || JSONP url
    //@param callback : Callback function if user needs data
    //@param mapBaseURL : Base URL of map service
    var init = function (url, mapServiceUrl, callback) {
        if(!url || !mapServiceUrl || !callback) {
            _error('Service must be initiated first ROAMAP.service.init(url, mapServiceUrl, callback)');
        };

        //Set map service url
        _mapServiceUrl = mapServiceUrl;
        var that = this;
        if(!_service) {
             jQuery.support.cors = true;
            $.ajax({
                url : url,
                dataType : 'json',
                crossDomain : true,
                method : 'GET',
                success : function (r) {
                    _service = r;
                    //Build Open Layers Objects
                    $.each(getProfiles(), function (idx, profileName) {
                        $.each(getMaps(profileName), function (idx, map) {
                            //Make sure we have an array
                            if(Object.prototype.toString.call(map.layers) === '[object Array]') {
                                layers = map.layers;
                            } else {
                                layers = [];
                                layers.push(map.layers);
                            }
                            $.each(layers, function (idx, layer) {
                                //Create Layer
                                layer.mapLayer = ROADMAP.ol.createLayer(layer);
                                if(layer.mapLayer) {
                                    layer.visible = false;
                                }
                                //Create Legend Item
                                layer.legend = null;
                                getLegItem(layer, function (r, cached) {
                                    if(!cached) {
                                        layer.legend = r;
                                    } else {
                                        layer.layerItems = r;
                                        layer.legend = r;
                                    }
                                });

                            });
                        });
                    });
                    //Return 'this' -> service pubic api methods
                    (callback) ? callback(that, true /*ASYNC*/) : null;
                },
                error : function (e) {
                    _error(e);
                }
            });
        } else {
            (callback) ? callback(that, false /*NOT ASYNC*/) : null;
        }
    };

    ////http://csc-s-gis-10-d.coast.noaa.gov/ArcGIS/rest/services/CCAP/All_Change_9606/MapServer/legend?f=json&pretty=true
    //@returns legend object
    //@summary Gets legend information using ESRI's REST API
    //@param
    var getLegItem = function (layer, callback) {
        //Avoid single external service
        
        var external = /https:/i, cached = false, url;
        if(external.test(layer.ServiceName)) {
            url = layer.ServiceName;
            cached = true
        } else {
            url = roadmapConfig.mapBaseUrl + layer.ServiceName + "/MapServer";
        }

        $.ajax({
            url : url + "/legend",
            data : {
                f : 'json'
            },
            dataType : 'jsonp',
            success : function (r) {
                //for esri service , project team doesnt want to use service layer names.  On the legend build, hijack object and rename.
                if(layer.LayerName == 'Projected Population Growth'){
                    $.each(r.layers, function(i,layerlgnd){
                         layerlgnd.layerName = layer.LayerName
                    });
                }



                if(!cached) {
                    $.each(r.layers, function (idx, obj) {

                        if(obj.layerId == layer.LayerId) {

                            var baseUrl = url + "/" + layer.LayerId + "/images/";
                            $.each(obj.legend, function (idx, item) {
                                item.imgUrl = baseUrl + item.url;
                                item.minScale = obj.minScale;
                                item.maxScale = obj.maxScale;

                            });

                            callback(obj.legend);
                        }
                    })
                } else {
                    //Handle cached layers
                    $.each(r.layers, function (idx, obj) {
                        var baseUrl = url + "/" + obj.layerId + "/images/";
                        $.each(obj.legend, function (idx, item) {
                            item.imgUrl = baseUrl + item.url;
                            item.minScale = obj.minScale;
                            item.maxScale = obj.maxScale;
                        });
                        //callback(obj.legend, baseUrl);
                    });
                    //Return layers with legend items

                    callback(r.layers, true)
                }
            },
            error : function (e) {
                console.warn(e);
            }
        })
    };


    //@returns ARRAY of profile strings
    //@summary Get all profiles for roadmap service
    var getProfiles = function () {
        if(_profiles.length === 0 && _service) {
            $.each(_service.Profiles, function (profile, maps) {
                //Add profile and set first index to feature profile
                if(roadmapConfig.featureProfile && profile === roadmapConfig.featureProfile) {
                    _profiles.unshift(profile)
                } else {
                    _profiles.push(profile);
                }
            });
        } else if (!_service) {
            _error('Service must be initiated first ROAMAP.service.init(url, mapServiceUrl, callback)');
            return false;
        }
        return _profiles;
    };

    //@returns array of maps and layers {}
    //@summary Get all maps that pertain to a given profile
    //@param profileName : the name of the profile
    //@param string : does user want just a stirng response
    var getMaps = function (profileName, string) {
        if(_service && profileName && string) {
            var maps = [];
            $.each(_service.Profiles[profileName], function (mapName, mapObj) {
                maps.push(mapName);
            })
            return maps;
        } else {
            if(_service && profileName) {
                return _service.Profiles[profileName];
            } else if(!profileName) {
                //_error('Required: getMaps(profileName)');
            } else {
                _error('Service must be initiated first ROAMAP.service.init(url, mapServiceUrl, callback)');
            }
        }
    };

    //@returns array of map layers
    //@summary Get layers for a profiles map topic
    //@param profileName : the name of the profile
    //@param mapName : the name of the map
    var getLayers = function (profileName, mapName) {
        if(_service && profileName && mapName) {
            return _service.Profiles[profileName][mapName].layers;
        } else {
            _error('Provide profileName and mapName');
        }
    };

    //@returns string or map service URL
    var getMapServiceUrl = function () {
        return (_mapServiceUrl) ? _mapServiceUrl : undefined;
    };

    var _error = function (message) {
        console.warn(message);
    }
    //reveal public API
    return {
        init : init,
        getProfiles : getProfiles,
        getMaps : getMaps,
        getLayers : getLayers,
        getMapServiceUrl : getMapServiceUrl
    }
}());

//URL manipulation for cached/dynamic service url
ROADMAP.namespace('url');

ROADMAP.url = (function () {
    var serviceUrl;

    //@summary Creates service url from layer object
    //@param layer The service layer from db service
    //@param type The type of REST url (export, query, identify...)
    var createServiceUrl = function (layer, type) {
        var external = /https:/i, url;
        //Default type to export service
        type = (type) ? type : 'export';
        if(external.test(layer.ServiceName)) {
            serviceUrl = layer.ServiceName + "/" + type;
        } else {
            serviceUrl = ROADMAP.service.getMapServiceUrl() + layer.ServiceName + "/MapServer/" + layer.LayerId + "/" + type;
        }
        return serviceUrl;
    };

    return {
        createServiceUrl : createServiceUrl
    }

}());




//Open Layers Map Interaction
ROADMAP.namespace('ol');

ROADMAP.ol = (function () {
    var map,
        layers,
        _profileLayers = {},
        _opacityFeature,
        _opacityMap,
        highestIndex = 0,
        featureLayers = {
            'ids' : [],
            'layers' : []
        },
        loadingIds = [],
        popup;


    //@returns layer object
    //@summary internal function to create openlayers layers
    //@param layer : layer object from roadmap service
    var createLayer = function (layer) {
        if(!OpenLayers) {
            console.warn('OpenLayers missing');
            return false;
        }

        var external = /https:/i, url;
        if(external.test(layer.ServiceName)) {
            url = layer.ServiceName + "/tile/${z}/${y}/${x}"; //was /export
        } else {
            url = ROADMAP.service.getMapServiceUrl() + layer.ServiceName + "/MapServer/tile/${z}/${y}/${x}"; //was /MapServer/export
        }

        var layerID = (!layer.LayerId) ? 0 : layer.LayerId;
        //now cached layers OpenLayers.Layer.XYZ
        /*var mapLayer = new OpenLayers.Layer.ArcGIS93Rest(layer.layerName,
                url, {
                layers : "show:" + layerID.toString(),
                transparent : true,
                isBaseLayer : false
        });*/

        var mapLayer = new OpenLayers.Layer.XYZ( layer.layerName,
                            url,
                            {sphericalMercator: true, transparent : true,
                        isBaseLayer : false} );



        //Determine Highest Z-Index
        if(layer.LayerIndex > highestIndex) {
            highestIndex = layer.LayerIndex;
        }

        return mapLayer;
    };

    //@returns layer object
    //@summary built to create layer specifically to location layer
    //@param opt : {url : '', layerId : 0, label : ''}
    var createLocationLayer = function (opt) {
        var counties = new OpenLayers.Layer.ArcGIS93Rest(opt.label,
            opt.url + 'Export', {
            layers : "show:" + opt.layerId,
            format : 'png8',
            transparent : true,
            isBaseLayer : false
        });

        if(counties) {
            return counties;
        }
    };

    //@summary Creates map object and embeds into div
    //@param div id of map
    var createMap = function (div,init) {
        //Create Map
        map = new OpenLayers.Map(div, {
            projection : "EPSG:900913",
            theme: null
        });
        //Create and Add layer

        //@Shaunak : Switched to using ESRI Base Maps
        var streets = new OpenLayers.Layer.XYZ('Street Map', roadmapConfig.baseMaps["street"] , {
                        transitionEffect: "resize",
                        sphericalMercator: true,
                        numZoomLevels: roadmapConfig.maxZoom || 15,
                        format: "image/jpg",
                    });

        var imagery = new OpenLayers.Layer.XYZ("Imagery", roadmapConfig.baseMaps["imagery"], {
                        transitionEffect: "resize",
                        sphericalMercator: true,
                        numZoomLevels: roadmapConfig.maxZoom || 15,
                        format: "image/jpg",
                    });

        //@Shaunak : Activate if city names and stuff is needed
        var reference = new OpenLayers.Layer.XYZ("Reference", roadmapConfig.baseMaps["reference"], {
                        transitionEffect: "resize",
                        sphericalMercator: true,
                        numZoomLevels: roadmapConfig.maxZoom || 15,
                        format: "image/png",
                        isBaseLayer: false
        });

        //@Shaunak : Dont Forget to add it
        map.addLayers([streets, imagery,reference]);
        if(init){
            if(init.extents){
                setTimeout(function () {
                    map.zoomToExtent(init.extents);
                }, 100);
            }
            if(init.basemap){
                map.setBaseLayer(map.getLayersByName(init.basemap)[0]);
            }
        }
        else{
            map.setCenter(new OpenLayers.LonLat(-90.087892, 35.60874).transform(
                new OpenLayers.Projection("EPSG:4326"),
                map.getProjectionObject()
            ), 5);
        }
    };


    //@summary Change baselayer based on an id
    //@param id 0 for street map 1 for satellite
    var changeBaseLayer = function (id) {
        map.setBaseLayer(map.layers[id]);
    };

    //@summary Adds a layer to the map
    //@param open layers layer object
    var addLayer = function (layer) {
        //Add Layer
        map.addLayer(layer);
    };

    //@summary Registers load events on map layers
    //@param layer service layer with mapLayer (open layers) object
    //@param callback do something when loading
    var _registerEvents = function (layer, callback) {
        //Layer Started Loading
        layer.mapLayer.events.register("loadstart", layer.mapLayer, function () {
            if($.inArray(layer.id, loadingIds) == -1) {
                loadingIds.push(layer.id);
            }
            if(callback) {
                callback(_loading());
            }
        });
        //Layer End Loading
        layer.mapLayer.events.register("loadend", layer.mapLayer, function () {
            loadingIds.splice($.inArray(layer.id, loadingIds), 1);
            if(callback) {
                callback(_loading());
            }
        });
    };

    //@summary get ids of loading layers
    var _getLoadingIds = function () {
        return loadingIds;
    };
    //@summary check if layers are loading
    var _loading = function () {
        return loadingIds.length > 0;
    };

    //summary Fix for errors when resizine map
    var resetSize = function () {
        map.updateSizeDestroy();
    };


    //@summary Adds and handles specific map layers
    //         related to the roadmap service
    //@param layers map layers to add
    //@param callback callback used for loading events
    //@returns Layers that were successfully added to the map
    var currentActiveLayers = [];
    var addMapLayer = function (layers, callback) {
        //Add to _profileLayers if new
        currentActiveLayers = [];
        var activeIds = [];
        var activeLayers = [];
        $.each(layers, function (idx, layer) {
            if(!_profileLayers[layer.id]) {
                //Create layer
                layer.mapLayer = ROADMAP.ol.createLayer(layer);
                _profileLayers[layer.id] = layer;

                //Register Load Events on Layer
                if(!callback) {
                    callback = false;
                }
                _registerEvents(layer, callback);
                //Add to map
                map.addLayer(layer.mapLayer);
                map.setLayerZIndex(layer.mapLayer, layer.LayerIndex);
            }
            activeIds.push(layer.id);
        });
        //Turn off all layers other layers except current

        $.each(_profileLayers, function (idx, obj) {
            if($.inArray(idx, activeIds) !== -1) {
                //Turn On
                obj.mapLayer.setVisibility(true);
                activeLayers.push(obj);

            } else {
                //Turn Off other map layers
                obj.mapLayer.setVisibility(false);
            }

            //Set initial opacity
            if(_opacityMap) {
                obj.mapLayer.setOpacity(_opacityMap);
            }
        });
        currentActiveLayers = activeLayers;
        return activeLayers;
    };

    //@summary Adds a feature layer to the map, which is not affected
    //         by which map or profile the user has active
    var addFeatureLayer = function (layer, callback) {
        //Check if layer has already been added to the map
        //if not add it
        if($.inArray(layer.id, featureLayers['ids']) == -1) {
            layer.mapLayer = ROADMAP.ol.createLayer(layer);
            featureLayers['ids'].push(layer.id);
            featureLayers['layers'].push(layer);
            //Register Load Events on Layer
            if(!callback) {
                callback = false;
            }
            _registerEvents(layer, callback);
            map.addLayer(layer.mapLayer);
        }
        map.setLayerZIndex(layer.mapLayer, (1 + +highestIndex + +layer.LayerIndex));
        layer.mapLayer.setVisibility(layer.visible);
        if(_opacityFeature) {
            layer.mapLayer.setOpacity(_opacityFeature);
        }
    };

    //@summary Get feature layers that are visible on the map
    //@returns Visible layers array
    var getFeatures = function () {
        var visibleFeatures = [];
        $.each(featureLayers['layers'], function (idx, layer) {
            if(layer.visible) {
                visibleFeatures.push(layer);
            }
        })
        return visibleFeatures;
    };

    var getLegends = function(){
        var lgndItems = [];
        var myMap = ROADMAP.ol.getMap();
        var currentScale = myMap.getScale();
        var hazardLyr = ROADMAP.ol.getFeatures();
        var exposureLyr =  currentActiveLayers;


        $.each(hazardLyr, function(i, val){
            var visLgnd = [];
            var lgnd = val.legend;

            $.each(lgnd, function(j, lgnditem){
                if((lgnditem.minScale == 0 && lgnditem.maxScale == 0) || ((lgnditem.minScale > currentScale || lgnditem.minScale == 0)   && lgnditem.maxScale < currentScale)){
                    delete lgnditem["$$hashKey"];
                    delete lgnditem["contentType"];
                    delete lgnditem["imageData"];
                    delete lgnditem["url"];
                    visLgnd.push(lgnditem);
                }
            });
            if(visLgnd.length > 0)lgndItems.push({
                "label":val.LayerName,
                "icons": visLgnd});

        });

        $.each(exposureLyr, function(i, val){
            /**
             * TODO: FIXME: HACK : This is bad smelly code and will need to be revisited
             *  Not sure how, but just for this layer, the legend was parsed to include all layers
             */
            if(val.LayerName === "Projected Population Growth"){
                val.legend = val.legend[0].legend;
            }
            /**
             * Bad Smelly Code ends..
             */
            lgndItems.push({
                "label":val.LayerName,
                "icons": val.legend
            });
        });
        return lgndItems;
    }

    //@summary Set feature layer opacity on the map
    //@param value : floating point opacity value (0-1)
    var setFeatureOpacity = function (value) {
        $.each(featureLayers['layers'], function (idx, layer) {
            layer.mapLayer.setOpacity(value);
        })
        _opacityFeature = value;
    }

    //@summary Get current feature layer opacity
    //@returns float
    var getFeatureOpacity = function () {
        return _opacityFeature;
    }

    //@summary Set map layer opacity
    //param value floating point opacity value (0-1)
    var setMapOpacity = function (value) {

        $.each(_profileLayers, function (idx, layer) {

            if(featureLayers['layers'].length){
                $.each(featureLayers['layers'], function(i,flayer){
                    if(flayer.LayerName != layer.LayerName){
                        layer.mapLayer.setOpacity(value);
                    }
                });
            }
            else{
                layer.mapLayer.setOpacity(value);
            }
        });
        _opacityMap = value;
    }

    //@summary Get map layer opacity
    //@returns float
    var getMapOpacity = function () {
        return _opacityMap;
    }

    //@summary Hide all feature layers.. but keep current visibility status
    var hideFeatureLayers = function () {
        $.each(featureLayers.layers, function (idx, obj) {
            obj.mapLayer.setVisibility(false);
        })
    };

    //@summary Refresh visibility status of a layer
    var updateMapVisibilityOf = function (layer){
        layer.mapLayer.setVisibility(layer.visible);
    };

    var showFeatureLayers = function () {
        $.each(featureLayers.layers, function (idx, obj) {
            obj.mapLayer.setVisibility(obj.visible);
        })
    };

    var resetMapLayers = function () {
        _profileLayers = {};
        featureLayers['ids'] = [];
        featureLayers['layers'] = [];
    };

    //@summary Removes all layers from the map (except base)
    var removeAllLayers = function () {
        //console.log('REMOVE ALL LAYERS');
    };

    //@returns boolean
    //@summary Check if map exists
    var mapSet = function () {
        return (!!map);
    };

    //@summary Pans map to given lat and lon
    var panTo = function (lon, lat) {
        map.panTo(new OpenLayers.LonLat(lon, lat));
    };

    //@returns map instance
    var getMap = function () {
        return map;
    };

    //@returns current layers
    var getLayers = function () {
        return map.layers;
    };

    //@summary Register map zoom events for legend
    var registerZoom = function($scope){
        map.events.register("zoomend", map, function(e){

        })
    }

    //@summary Register map click events for identify
    var registerIdentify = function () {
        map.events.register("click", map, function (e) {
            var identifyPromises = [];
            //Get Coordinates of Click event
            var lonlat = map.getLonLatFromPixel(e.xy);
            //Query active features (For All featureLayers)
            if(ROADMAP.profile.active() === "Flood_Hazards"){
                var mylayers = map.layers;
                $.each(mylayers, function(idx, layer){
                        if(layer.url && layer.url.match('CoastalFloodHazardComposite') && layer.visibility != false){
                            var promise = _queryLayer(roadmapConfig.noaaBaseUrl + 'FloodExposureMapper/CompositeQuery/MapServer/0/query', lonlat);

                            identifyPromises.push(promise);
                        }
                });
            }
            else{
                $.each(featureLayers.layers, function (idx, layer) {
                    //GENERATE URL FROM LAYER TYPE
                    if(layer.visible && layer.LayerName == 'Coastal Flood Hazard Composite') {
                        var promise = _queryLayer(ROADMAP.url.createServiceUrl(layer, "query"), lonlat);
                        identifyPromises.push(promise);
                    }
                });
            }



            //Open Popup
            if(identifyPromises.length > 0) {
                identifyPopup(lonlat, "<div>LOADING...</div>", identifyPromises);
            }
        },true)
    };

    //@summary Query a layer
    var _queryLayer = function (url, center) {
        return $.ajax({
            url : url,
            data : {
                geometryType : "esriGeometryPoint",
                geometry : center.lon.toString() + "," + center.lat.toString(),
                f : "json",
                outFields : "*",
                returnGeometry : false
            },
            dataType : 'jsonp',
            type : 'GET'
        })
    };

    //@summary Creates a popup box
    //@param lonlat Open layers lonlat object
    //@param content Content to append to info window
    var identifyPopup = function (lonlat, content, contentPromises) {
        //Remove any old popup
        if(popup) {
            map.removePopup(popup);
            popup = false;
        }
        //Create popup object
        popup = new OpenLayers.Popup.FramedCloud("popup",
                           lonlat,
                           new OpenLayers.Size(50, 50),
                           content,
                           null,
                           true);
        popup.isAlphaImage = true;
        //Add popup to map
        map.addPopup(popup, true);
        //Set Z-Index
        $("#popup").css("z-index", "9999");

        //Update content if waiting on ajax call
        if(contentPromises) {
            var newContent = "";
            $.when.apply($, contentPromises).done(function (r) {
                $.each(contentPromises, function (idx, obj) {
                    if(obj.responseJSON && obj.responseJSON.features.length > 0) {
                        //Use index 0 because should be single feature

                        //kf comment out to remove "Result" header from popover
                        //newContent += "<h3>" + "Result " + (idx + 1) + "</h3>";

                        newContent += "<ul class='unstyled'>";
                        $.each(obj.responseJSON.features[0].attributes, function (attr, val) {
                            if(attr == "HAZ_NUM"){
                                    newContent += "<li>";
                                    newContent += "<strong>" + "Number of Hazards: " + "</strong>" + val;
                                    newContent += "</li>";
                            }
                            if(attr == "DESCRPTN"){
                                
                                var parseVal = val.split(',');                               
                                    newContent += "<li>";
                                    newContent += "<strong>" + "Hazard Zones: " + "</strong><br/>";
                                    newContent += "<ul>"
                                    $.each(parseVal, function(i,v){
                                        newContent += "<li>"+ v +"</li>";
                                    })
                                    newContent += "</ul>"
                                    newContent += "</li>";
                            }

                        })
                        newContent += "</ul>";
                    }
                })
                if(newContent == "") {
                    popup.destroy();
                } else {
                    popup.setContentHTML("<div class='map-popover-content'>"+newContent+"</div>");
                    popup.panIntoView();
                }
            })
        }
    };

    var getPopup = function () {
        return (popup) ? popup : false;
    }

    //reveal public API
    return {

         createLayer : createLayer,
         createLocLayer : createLocationLayer,
         createMap : createMap,
         addLayer : addLayer,
         addMapLayer : addMapLayer,
         addFeatureLayer : addFeatureLayer,
         hideFeatureLayers : hideFeatureLayers,
         showFeatureLayers : showFeatureLayers,
         resetMapLayers : resetMapLayers,
         removeAllLayers : removeAllLayers,
         mapSet : mapSet,
         panTo : panTo,
         getMap : getMap,
         getLayers : getLayers,
         getFeatures : getFeatures,
         setFeatureOpacity : setFeatureOpacity,
         getFeatureOpacity : getFeatureOpacity,
         setMapOpacity : setMapOpacity,
         getMapOpacity : getMapOpacity,
         registerZoom : registerZoom,
         registerIdentify : registerIdentify,
         getPopup : getPopup,
         changeBaseLayer : changeBaseLayer,
         updateMapVisibilityOf:updateMapVisibilityOf,
         getLegends : getLegends
    }
}());

//Handles user location selection and changes
ROADMAP.namespace('location');

ROADMAP.location = (function () {
    //location functions
    var currentLocation,
        counties = null,
        locationLayer,
        url, layerId,
        highlightLayer, activeLayer;

    //@returns Array of states and counties [{}] and if callback is async or not
    //@summary Add location layer to map and return list of counties
    //@param options : {url : '', layerId : 0, label : ''}
    //@param callback
    var init = function (options, callback) {
        if(!ROADMAP.ol.mapSet()) {
            console.error('Map needs to be initialized first');
            return false;
        };

        url = options.url;
        layerId = options.layerId;

        //Clear any previous layers
        locationLayer = highlightLayer = activeLayer = null;

        //Create layer
        locationLayer = ROADMAP.ol.createLocLayer(options);
        ROADMAP.ol.addLayer(locationLayer);
        locationLayer.setOpacity(options.opacity);

        //Add current Location if already stored
        if(current()) {
            highlightLocation(current().results[0].attributes.COUNTY_NAME, 'polygon', true);
        }

        //Return list of all counties
        if(!counties) {
            counties = {};
            var extent = locationLayer.getExtent();
            ROADMAP.ol.getMap().zoomToExtent(extent);
            var envelope = extent.toBBOX();
            //get all counties
            $.ajax({
                url : url + layerId + "/query",
                data : {
                    text : '%',
                    returnGeometry : 'false',
                    outFields : 'COUNTY_NAME,STATE_NAME',
                    f : 'pjson',
                    geometryType : 'esriGeometryEnvelope'
                },
                method : 'GET',
                dataType : 'jsonp',
                success : function (r) {
                    //Store Counties
                    $.each(r.features, function (idx, obj) {
                        if(!counties[obj.attributes.STATE_NAME]) {
                            counties[obj.attributes.STATE_NAME] = [];
                        }
                        counties[obj.attributes.STATE_NAME].push(obj.attributes.COUNTY_NAME);
                    });
                    (callback) ? callback(counties, true /*Async*/) : null;
                },
                error : function (e) {
                    console.warn(e);
                }
            });
        } else {
            (callback) ? callback(counties, false /*Not Async*/) : null;
        }
    }

    //@summary Get locations only, and not initialize init map
    //@param options : {url : '', layerId : 0, label : ''}
    //@param callback
    var getLocations = function (options, callback) {
        if(!counties) {
            counties = {};
            url = options.url;
            layerId = options.layerId;
            $.ajax({
                url : url + layerId + "/query",
                data : {
                    text : '%',
                    returnGeometry : 'false',
                    outFields : 'COUNTY_NAME,STATE_NAME,FIPSSTCO',
                    f : 'pjson',
                    geometryType : 'esriGeometryEnvelope'
                },
                method : 'GET',
                dataType : 'jsonp',
                success : function (r) {
                    //Store Counties
                    $.each(r.features, function (idx, obj) {
                        if(!counties[obj.attributes.STATE_NAME]) {
                            counties[obj.attributes.STATE_NAME] = [];
                        }
                        counties[obj.attributes.STATE_NAME].push({
                            name: obj.attributes.COUNTY_NAME,
                            fips: obj.attributes.FIPSSTCO
                        });
                    });
                    (callback) ? callback(counties, true /*Async*/) : null;
                },
                error : function (e) {
                    console.warn(e);
                }
            });
        } else {
            (callback) ? callback(counties, false /*Not Async*/) : null;
        }
    }




    var removeActiveLayer = function () {
        activeLayer = null;
    }

    //@summary Highlight a location on the map
    //@param countyName : The name of the county to highlight
    //@param geometry : point or polygon (defualt point)
    //@param active : Set the active county
    //@param callback : callback function to fire once ajax is complete
    var highlightLocation = function (countyFIPS, geometry, active, callback) {
        //Default point
        geometry = (geometry) ? geometry : 'point';

        //Add point to the map
        function addHighlight(r) {
            //Create or clear highlighted layer
            if(highlightLayer) {
                highlightLayer.removeAllFeatures();
            } else {
                highlightLayer = new OpenLayers.Layer.Vector("highlight",
                    {style : OpenLayers.Feature.Vector.style["default"]}
                );
                ROADMAP.ol.addLayer(highlightLayer);
            }

            if(active) {
                //Set Current
                current(r);
                if(ROADMAP.ol.getLayers().length === 1) {
                    activeLayer = null;
                }
                if(activeLayer) {
                    activeLayer.removeAllFeatures();
                } else {
                    activeLayer = new OpenLayers.Layer.Vector("activeCounty",
                        {
                            style : OpenLayers.Feature.Vector.style["default"]
                        }
                    );
                    ROADMAP.ol.addLayer(activeLayer);
                    ROADMAP.ol.getMap().setLayerZIndex(activeLayer, 99);
                }
            }

            //Create Geometry
            var point, olPoints = [];
            $.each(r.results[0].geometry.rings[0], function (idx, points) {
                point = new OpenLayers.Geometry.Point(points[0], points[1]);
                olPoints.push(point);
            });

            var linear_ring = new OpenLayers.Geometry.LinearRing(olPoints);
            var center = linear_ring.getCentroid();

            if(geometry === 'point') {
                var feature = new OpenLayers.Feature.Vector(
                    new OpenLayers.Geometry.Point(center.x, center.y)
                    //{some : 'data'},
                    //{externalGraphic : 'img/marker.png', graphicHeight : 21, graphicWidth : 16}
                );
            } else {
                if(!active) {
                    //Highlight Layer
                    var feature = new OpenLayers.Feature.Vector(
                        new OpenLayers.Geometry.Polygon([linear_ring]),
                        {county : countyFIPS},
                        {
                            fillColor : '#4EC6DE',
                            fillOpacity : 0.5,
                            strokeWidth : null
                        }
                    );
                } else {
                    //Active Layer
                    var opacity = (geometry === 'none') ? 0 : 0.5;
                    var feature = new OpenLayers.Feature.Vector(
                        new OpenLayers.Geometry.Polygon([linear_ring]),
                        {county : countyFIPS},
                        {
                            fillColor : '#000',
                            fillOpacity : opacity,
                            strokeWidth : 2
                        }
                    );
                }
            }

            if(active) {
                activeLayer.addFeatures([feature]);
                ROADMAP.ol.addLayer(activeLayer);
                //console.log(feature.geometry.getBounds().toString());
                ROADMAP.ol.getMap().zoomToExtent(feature.geometry.getBounds());
            } else {
                //Prevent highlighting if active layers
                if(activeLayer && activeLayer.features.length !== 0) {
                        return false;
                }

                highlightLayer.addFeatures([feature]);
                ROADMAP.ol.addLayer(highlightLayer);
                ROADMAP.ol.panTo(center.x, center.y);
            }

        }

        //Get Geometry from county name
        $.ajax({
            url : url + "/find",
            data : {
                searchText : countyFIPS,
                searchFields : 'FIPSSTCO',
                contains : 'false',
                layers : layerId,
                f : 'pjson'
            },
            method : 'GET',
            dataType : 'jsonp',
            success : function (r) {
                addHighlight(r);
                if(callback) {
                    callback(r);
                }
            },
            error : function (e) {
                console.warn(e);
            }
        })
    };

    //@summary Clears the currently selected location
    var clear = function () {
        if(activeLayer){
            highlightLayer.removeAllFeatures();
            activeLayer.removeAllFeatures();
            currentLocation = undefined;
        }
    }

    //@returns Returns current location
    //@summary Getter and Setter for location
    //@param loc : current location for setter
    var current = function (loc) {
        //Get
        if(!loc) {
            return (currentLocation) ? currentLocation : undefined;
        }
        //Set
        currentLocation = loc;
    };

    return {
        init : init,
        current : current,
        highlight : highlightLocation,
        clear : clear,
        getLocations : getLocations,
        removeActiveLayer : removeActiveLayer
    }
}());

//Set and store active profile
ROADMAP.namespace('profile');

ROADMAP.profile = (function () {
    var activeProfile;

    var active = function (name) {
        if(name) {
            activeProfile = name;
        }
        return activeProfile;
    }

    var clear = function () {
        activeProfile = undefined;
    }

    return {
        active : active,
        clear : clear
    }
}());


//Storage for output products
ROADMAP.namespace('cart');

ROADMAP.cart = (function () {
    //Cart functions
    var _cartItems = [], _cartItem, exportImages;

    //@summary exports images of map layers
    //@param cartItem : cart item object
    //@param dimensions : {h: height, w: width}
    //@param callback : callback function once images are complete
    //@param exportUrl : return export URL instead of image
    //@returns array of map images
    var buildMapImages = function (cartItem, dimensions, callback, exportUrl) {
        var promiseArr = []; exportImages = [];
        //Default image dimensions of 300x300px
        dimensions = (dimensions) ? dimensions : '300,300';

        //Build url based on cached or dynamic layer
        function constructUrl(layer) {
            var external = /https:/i, cached = false, url;
            if(external.test(layer.ServiceName)) {
                url = layer.ServiceName;
            } else {
                url = roadmapConfig.mapBaseUrl + layer.ServiceName + "/MapServer";
            }
            return url;
        }

        //Request image from service via export api
        function request(layer) {
            layer.exportUrl = layer.exportUrl.replace("https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services",
                       "//maps.coast.noaa.gov/arcgis/rest/services/FloodExposureMapper");

                var config = {
                url : layer.exportUrl + "/export",
                data : {
                    size : dimensions,
                    bbox : '' + cartItem.extent.left + "," + cartItem.extent.bottom + "," +
                             + cartItem.extent.right + "," + cartItem.extent.top,
                    transparent : 'true',
                    format : 'png24',
                    dpi : '96',
                    f : 'json'
                },
                dataType : 'jsonp'
            };

            //If Dynamic, include layer
            /*if(layer.LayerId) {
                config.data.layers = "show:" + layer.LayerId;
            }*/

            //Return URL instead of deferred object
            if(exportUrl) {
                config.data.f = 'image';
                return(config.url + "?" + $.param(config.data));
            }

            //Return deferred object
            return $.ajax(config);
        };

        //Basemap Layer
        var basemap = {
            ServiceName : cartItem.baseMap
        };

        //Request basemap separate
        basemap.exportUrl = constructUrl(basemap);
        promiseArr.push(request(basemap));

        //Map layers
        var layers = ROADMAP.service.getLayers(cartItem.profileID, cartItem.mapID);
        if(Object.prototype.toString.call(layers) !== '[object Array]') {
            layers = [layers];
        }

        $.each(layers, function (idx, layer) {
            layer.exportUrl = constructUrl(layer);
            promiseArr.push(request(layer));
        });


        //Feature layers
        var featureLayers;
        if(cartItem.features) {
            //Don't print feature layers if current profile is feature profile
            if(roadmapConfig.featureProfile && (roadmapConfig.featureProfile !== cartItem.profileID)) {
                featureLayers = cartItem.features;
                if(Object.prototype.toString.call(featureLayers) !== '[object Array]') {
                    featureLayers = [featureLayers];
                }
                //Request
                $.each(featureLayers, function (idx, layer) {
                    layer.exportUrl = constructUrl(layer);
                    promiseArr.push(request(layer));
                });
            }
        }

        //If handle callback, handle here
        if(callback) {

            $.when.apply($, promiseArr).done(function () {

                $.each(promiseArr, function (idx, obj) {
                    if(obj.responseJSON) {
                        exportImages.push(obj.responseJSON.href);
                    }
                });

                callback();
            });

            return exportImages;
        } else {
            //else handle defered objects elsewhere
            return promiseArr;
        }
    };

    //@summary add an item to the cart
    //@parem profileName : The name of the profile (String)
    //@param mapName : The name of the map (String)
    //@param callback : Callback function when layers imags are created DEPRECATED
    //@param features : Feature layers currenty active (array)
    //@param extent : Current Map extent (open layers bounds object)
    //@param basemap : INCLUDE LATER
    //@returns : returns cart items array
    var addItem = function (profileName, mapName,message,callback, features, extent, basemap) {
        //mapName is required
        if(!mapName) {
            console.warn('MapID Needed');
            return false;
        }

        _loading = true;

        //Define features and extent if not provided
        features = (features) ? features : ROADMAP.ol.getFeatures();
        extent = (extent) ? extent : ROADMAP.ol.getMap().getExtent();
        var legend = ROADMAP.ol.getLegends();
        //Add cart item to array
        _cartItem = {
            profileID : profileName,
            baseMap: ROADMAP.ol.getMap().baseLayer.url.replace("tile/${z}/${y}/${x}",""),
            mapID : mapName,
            mapMessage:message,
            features : features,
            featureOpacity: ROADMAP.ol.getFeatureOpacity(),
            exposureOpacity: ROADMAP.ol.getMapOpacity(),
            legend : legend,
            extent : extent,
            shareUrl : ROADMAP.output.shareMapUrl(profileName,
                                                  mapName,
                                                  features,
                                                  extent,
                                                  basemap,
                                                  ROADMAP.ol.getFeatureOpacity(),
                                                  ROADMAP.ol.getMapOpacity()
                                                  )
        };

        _shortenURLForCart(_cartItem); //asynchronously adds shortShareURL to shortened version if not on localhost

        //Build Cart Thumbs
        _cartItem.images = buildMapImages(_cartItem, roadmapConfig.mapThumbs, false, true);
        _cartItems.push(_cartItem);

        //Build PNG for faster loading times and loading status
        if(callback){
            buildMapImages(_cartItem, roadmapConfig.mapThumbs, callback, false);
        }

        return _cartItems;
    };

    var _shortenURLForCart = function (cart) {
            if (_isOnGovDomain()) {
                $.ajax({
                    url: 'https://go.usa.gov/api/shorten.jsonp',
                    dataType: 'jsonp',
                    data: {
                        login: 'shaunakv1',
                        apiKey: '255ac59faa21fc1a1821ff1be304b833',
                        longUrl: cart.shareUrl
                    },
                    success: function(res, textStatus, xhr) {
                        var u = res.response.data.entry[0].short_url;
                        cart.shortShareUrl = u;
                    }
                });
            }
    };
    var _isOnGovDomain = function() {
        return document.domain.indexOf('.gov') >= 0;
    }

    //@summary Remove an item by its index
    //@param cartIndex : Index of item to be remobed
    //@returns Cart items array
    var removeItem = function (cartIndex) {
        //Index must be provided
        if(!(""+cartIndex)) {
            console.warn('Index must be provided to remove a cart item');
            return false;
        }
        _cartItems.splice(cartIndex, 1);
        return _cartItems;
    }

    //@summary Reveal private cart items array
    //@returns cart array
    var getCartItems = function () {
        //If empty, return falsey
        if(_cartItems.length === 0) {
            return 0;
        }
        return _cartItems;
    }

    //@summary Clear the cart
    var empty = function () {
        _cartItems = [];
    }

    var isLoading = function () {
        return _loading;
    }

    //@summary Check if images are still valid (they are temporary on server)
    //@returns (boolean)
    var expired = function (callback) {
        var items = [];
        var isExpired = false;
        //Check if url returns 404
        function urlExists(imgurl) {
          return $.ajax({
            url : './php/brokenLinks.php',
            data : {'imageURL' : imgurl},
            type : 'GET'
          });
        }

        $.each(_cartItems, function (idx, item) {
            $.each(item.images, function (idx, image) {
                items.push(urlExists(image));
            });
        });

        $.when.apply($, items).done(function () {
            $.each(items, function (idx, item) {
                if(item.responseText == "404") {
                    isExpired = true;
                    return false;
                }
            });
            callback(isExpired);
        })
    }

    //@summary empties expired images
    //@returns cart items
    var clearImages = function () {
        $.each(_cartItems, function(idx, item) {
            item.images = [];
        })
        return _cartItems;
    }

    var refreshImages = function (callback) {
        var promises = [];
        $.each(_cartItems, function (idx, layer) {
             var promise = buildMapImages(layer, roadmapConfig.mapThumbs);
             promises = promises.concat(promise);
             $.when.apply($, promise).done(function () {
                $.each(promise, function (idx, obj) {
                    layer.images.push(obj.responseJSON.href);
                });
             });
        });
        $.when.apply($, promises).done(function () {
            callback(_cartItems);
        });
    }

    return {
        add : addItem,
        remove : removeItem,
        get : getCartItems,
        empty : empty,
        buildImages : buildMapImages,
        isLoading : isLoading,
        expired : expired,
        refreshImages : refreshImages,
        clearImages : clearImages
    }
}());

//Handle output of maps
ROADMAP.namespace('output');

ROADMAP.output = (function () {
    //printing & exporting functions

    //@summary Builds Image URLs for PDF
    //@param callback : do something when done preparing images
    var createImages = function (callback) {
        $.each(ROADMAP.cart.get(), function (idx, map) {
            var images = ROADMAP.cart.buildImages(map, roadmapConfig.mapFull, false, true);
            map.fullImages = images;
        });
        callback();
    }

    //@summary Builds Map URL for sharing
    //@param profileName The name of the current profile
    //@param mapName The name of the current map (or ID of map)
    //@param features Active features on the map
    //@param extent open layers extent
    //@param basemap ID of the current basemap NOT YET IMPLEMENTED
    //@returns The map URL String
    var shareMapUrl = function (profileName, mapName, features, extent, basemap,hazardOpacity, exposureOpacity) {
        var baseUrl = window.document.URL;
        baseUrl = baseUrl.split("#")[0] + "#/" + roadmapConfig.shareRoute;

        var params = [];
        params.push(profileName);
        params.push(exposureOpacity);
        params.push(mapName);
        //Create URL params
        var fArr = [];
        $.each(features, function (idx, layer) {
            fArr.push(layer.ShareId);

        });
        params.push(fArr.toString());
        params.push(hazardOpacity);
        //Create extent
        extent = [extent.left, extent.bottom, extent.right, extent.top];
        params.push(extent.toString());

        //Push base map
        params.push(ROADMAP.ol.getMap().baseLayer.name);

        baseUrl += "/" + params.join("/");
        return baseUrl;
    }

    return {
        createImages : createImages,
        shareMapUrl : shareMapUrl
    }
}());



